import Cookies from 'js-cookie'
const TokenKey = 'appcreat-Admin-Token';
const username = 'appcreat-Admin-Name';
const Wxappid = 'appcreat-Admin-Wxappid';
const istempadmin = 'appcreat-Admin-tempadmin';
var siteurl = 'http://diy.eingdong.com/service/index.php';

export function setToken(data){
	return Cookies.set(TokenKey, data)
}
export function getToken(){
	return Cookies.get(TokenKey)
}
export function removeToken(){
	return Cookies.remove(TokenKey)
}



export function setName(data){
	return Cookies.set(username, data)
}
export function getName(){
	return Cookies.get(username)
}
export function removeName(){
	return Cookies.remove(username)
}

export function getUrl() {
  let host = "diy.eingdong.com";
  // if(host == "abc.com:9527"){
  //   host = "diy.eingdong.com"
  // }
  return "https://"+host+'/service/index.php'
}



export function setWxappid(data){
	return Cookies.set(Wxappid, data)
}
export function getWxappid(){
	return Cookies.get(Wxappid)
}
export function removeWxappid(){
	return Cookies.remove(Wxappid)
}



export function set_template_admin(data){
	return Cookies.set(istempadmin, data)
}
export function get_template_admin(){
	return Cookies.get(istempadmin)
}
export function del_template_admin(){
	return Cookies.remove(istempadmin)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js